<template>
  <div class="SidebarFields product-wrapper d-flex" :class="{fullPage}">
    <div class="product-sidebar d-flex padding">
      <div class="inputs-grid mb-3" :class="skeClass">
        <FormInput
          v-model="$v.product_stock.$model"

          class="sm form-element"
          :ske="true"
          :vuelidate="$v"
          fieldName="product_stock"

          id="product_stock"
          label="Voorraad"
        />
        <FormInput
          v-model="$v.sku.$model"

          class="sm form-element"
          :ske="true"
          :vuelidate="$v"
          fieldName="sku"
          :disabled="true"

          id="sku"
          label="SKU"
        />
        <FormPriceInput
          v-model="$v.buy_price.$model"

          id="buy_price"
          :ske="true"
          label="Inkoop Prijs"

          :vuelidate="$v"
          fieldName="buy_price"
        />
        <FormPriceInput v-model="$v.recommended_retail_price.$model"
          id="recommended_retail_price"
          :ske="true"
          label="Verkoop Advies Prijs"

          :vuelidate="$v"
          fieldName="recommended_retail_price"
        />
        <FormPriceInput
          v-model="$v.special_price.$model"

          id="special_price"
          :ske="true"
          label="Aanbieding Prijs"

          :vuelidate="$v"
          fieldName="special_price"
        />

        <!-- <FormPriceInput
          v-model="$v.special_price.$model"

          class="sm form-element"
          :ske="true"
          :vuelidate="$v"
          fieldName="special_price"

          id="special_price"
          label="Speciale prijs"
        /> -->

        <!-- <FormPercentageInput v-if="allow_discount" v-model="discount_percentage"
          id="discount_percentage"
          :ske="true"
          label="Kortingspercentage"

          :vuelidate="$v"
          fieldName="discount_percentage"
        /> -->


        <FormSelect v-model="$v.tax.$model"
          id="size"
          :ske="true"
          label="BTW"

          :options="taxOptions"
        />
        <EditableBarcode
          :value="$v.ean13.$model"
          :always-open="true"
          :skip-enter="true"
          @save="ean13 => $v.ean13.$model = ean13"
        >
        </EditableBarcode>
      </div>
      <div class="d-flex align-items-center padding-bottom items-center" :class="skeClass">
        <div class="d-flex items-center">

          <FormCheckbox v-model="allow_discount"
            class="checkbox"
            :ske="true"
            :gray-color="true"
          >
            {{ !allow_discount ? "Korting toestaan" : "" }}

          </FormCheckbox>


        </div>
        <DiscountDropdown v-if="allow_discount"
          :vuelidate="$v"
        >
          <span>
            Korting toestaan
          </span>
        </DiscountDropdown>
        <span class="pl-2" v-if="this.discount_percentage">{{this.discount_percentage}}%</span>

      </div>


      <div class="tier_section">
        <FormCheckbox
          class="checkbox"
          v-model="checked"
          id="tier_price"
          fieldName="tier_price"
        >
          Tier price
        </FormCheckbox>
      </div>

      <div class="sidebar-section">
        <h4 class="card-title">Groothandel</h4>

        <div class="inputs-grid padding-bottom" :class="skeClass">
          <FormPriceInput
            v-model="$v.wholesale_price.$model"

            id="wholesale_price"
            :ske="true"
            label="Groothandel Prijs"

            :vuelidate="$v"
            fieldName="wholesale_price"
          />
          <FormInput
            v-model="$v.wholesale_stock.$model"

            id="wholesale_stock"
            :ske="true"
            label="Groothandel Voorraad"

            :vuelidate="$v"
            fieldName="wholesale_stock"
          />
        </div>
        <div class="inputs-grid padding-bottom" :class="skeClass">
            <FormInput v-model="$v.wholesale_ean.$model"
            class="form-element"
            id="wholesale_ean"
            :ske="true"
            label="EAN 13"

            :vuelidate="$v"
            fieldName="wholesale_ean"
          />
          <FormInput
            v-model="$v.colli.$model"
            id="colli"
            :ske="true"
            label="Colli"
            fieldName="colli"
          />
        </div>

        <div class="inputs-grid padding-bottom" :class="skeClass">
          <FormInput
            v-model="$v.wholesale_min_qty.$model"

            class="sm form-element"
            :ske="true"
            :vuelidate="$v"
            fieldName="wholesale_min_qty"

            id="wholesale_min_qty"
            label="Groothandel minimale hoeveelheid"
          />
        </div>

      </div>
      <div class="sidebar-section">
        <h4 class="card-title">Toon dit product op de bedankpagina</h4>
        <p>Welke kortingen mag dit product hebben.
        </p>

        <div class="inputs-grid padding-bottom" :class="skeClass">
          <FormCheckbox v-model="$v.low_discount_allow.$model">
            Lage korting
          </FormCheckbox>
          <FormCheckbox v-model="$v.medium_discount_allow.$model">
            Medium korting
          </FormCheckbox>
          <FormCheckbox v-model="$v.high_discount_allow.$model">
            Hoge korting
          </FormCheckbox>
        </div>

      </div>
      <div class="categories">
        <ManageCategories ref="manage-categories"
          title="Title"
          description="Description"

          :removeSkeletonClass="false"
          :product="categoriesProduct"
          :updateProduct="updateProduct"
          :handle-promise="false"

          height-limit="300px"

          :showCategories="true"
          :remove-card-style="true"
        />
      </div>

      <div class="list-options padding-top" :class="skeClass">
        <!-- <ListGroup
          v-model="listOptions"
        /> -->
        <FormSearchSelector v-model="brand"
          id="brand"
          :ske="true"
          label="Merk"
          placeholder="Zoek merk..."
          titleField="name"
          uid="uid"

          endpoint="/api/brands"

          :vuelidate="$v"
          fieldName="brand"

          v-slot="item"
        >
          <ProductListItem v-bind="item"/>
        </FormSearchSelector>
        <FormSearchSelector v-model="supplier"
          id="supplier"
          :ske="true"
          label="Leverancier"
          placeholder="Zoek leverancier..."
          titleField="name"
          uid="uid"

          endpoint="/api/suppliers"

          :vuelidate="$v"
          fieldName="supplier"

          v-slot="item"
        >
          <ProductListItem v-bind="item"/>
        </FormSearchSelector>
      </div>
    </div>
  </div>
</template>

<script>

import setupForm from "../../../../mixins/setupForm"
import tableFieldOptions from "../../../../mixins/tableFieldOptions"
// import fixDecimalCommaNotation from "../../../../mixins/fixDecimalCommaNotation"

import ProductListItem from "../../ProductListItem.vue"
import FormSearchSelector from "../../../Inputs/FormSearchSelector.vue"
import FormInput from "../../../Inputs/FormInput.vue"
import FormPriceInput from "../../../Inputs/FormPriceInput.vue"
import FormPercentageInput from "../../../Inputs/FormPercentageInput.vue"
import FormSelect from "../../../Inputs/FormSelect.vue"
import FormCheckbox from "../../../Inputs/FormCheckbox.vue"
import DiscountDropdown from "./DiscountDropdown.vue"
import ManageCategories from "../../../../layout/ManageCategories.vue"
import ListGroup from "./ListGroup.vue"
import EditableBarcode from "../../../../layout/EditTableItem/EditableBarcode.vue"

const fields = ["low_discount_allow", "medium_discount_allow", "high_discount_allow", "product_stock", "wholesale_min_qty", "sku", "tax", "amount", "recommended_retail_price", "buy_price", "tier_price", "wholesale_price", "wholesale_stock", "wholesale_ean", "colli", "special_price", "discount_percentage", "supplier", "brand", "ean13"]

import { required } from "vuelidate/lib/validators"

const decimal = value => {
  return (value + "").replace(/,/, ".").match(/^[-]?\d*(\.\d+)?$/) ? true : false
}

/*
  recommended_retail_price can only be set higher than the default value, never lower.
  If allow_discount is enabled, then verkoop price can be lower up until the value of discount_percentage

  todo: discuss this functionality. Should only apply between recommended price between products and website products.
*/

const notLowerThanDefaultValue = (value, vm) => {
  if (!vm.buy_price) return true

  const recommended = parseFloat((value + "").replace(/,/, "."), 10)
  const buy_price = parseFloat((vm.buy_price + "").replace(/,/, "."), 10)

  if (isNaN(recommended) || isNaN(buy_price)) return false
  if (vm.allow_discount) {
    const discount = parseFloat(
      (vm.discount_percentage + "").replace(/,/, ".") || 0, 10
    )
    const discountedBuyPrice = ((1 - (discount / 100)) * buy_price)

    return recommended >= discountedBuyPrice
  }

  return recommended >= buy_price
}

export default setupForm(fields, {
  mixins: [
    tableFieldOptions,
    /* fixDecimalCommaNotation(
      [],
    ), */
  ],
  components: {
    FormSearchSelector,
    ListGroup,
    DiscountDropdown,
    FormInput,
    FormPriceInput,
    FormSelect,
    ProductListItem,
    FormCheckbox,
    ManageCategories,
    FormPercentageInput,
    EditableBarcode,
  },
  validations: {
    recommended_retail_price: {
      required,
      // notLowerThanDefaultValue,
      decimal,
    },
    buy_price: {
      // notLowerThanDefaultValue,
      decimal,
    },
    product_stock: {
      decimal,
    },
    wholesale_stock: {
      decimal,
    },
    ean13: {
    },
  },
  props: {
    productId: String,
    skeClass: String,
    fullPage: Boolean,
  },
  data() {
    return {
      allow_discount: false,
      checked: false,
      listOptions: {
        suppliers: [],
        websites: [],
        productgroups: [],
      },
      low_discount_allow: false,
      high_discount_allow: false,
      medium_discount_allow: false,

      product: {categories: null},
    }
  },
  async created() {
    this.$v.wholesale_min_qty.$model = 1
    if (!this.productId || (this.productId && this.$route.name !== 'Edit product')) {
      const {sku} = (await this.axios.get(`/api/sku`)).data
      // const {ean13} = (await this.axios.get(`/api/ean13`)).data
      this.$v.sku.$model = sku
      // this.$v.ean13.$model = ean13
    }

    if (this.initialSource && this.initialSource.categories) {
      this.product.categories = this.initialSource.categories.slice()
    } else {
      this.product = {categories: []}
    }
  },
  methods: {
    async updateProduct({ categories }) {
      this.product = { categories: categories.filter(uid => uid) }
    },
  },
  computed: {
    categoriesProduct() {
      const pro = this.product
      const cats = pro && pro.categories
      if (!cats) return;

      if (typeof cats[0] !== "string") {
        return { categories: cats }
      }

      return {
        categories: cats.map(uid => ({ uid })),
      }
    },
  },
  watch: {
    initialSource(val) {
      if (val) {
        if(val.tier_prices.length) {
          this.checked = true
        }
        this.product = {
          categories: val.categories.slice(),
        }
      }
      this.mapInputToLocalDataVariable(val)
    },
    allow_discount(val) {
      if (!val) {
        this.$v.discount_percentage.$model = ""
        this.$v.buy_price.$model = ""
      }
    },
    checked(val) {
      this.$v.tier_price.$model = val
    },
    discount_percentage(val) {
      if (val) this.allow_discount = true
    },

    listOptions() {
      this.updateForm()
    },
  },
}, (data, vm) => {
  return {
    ...data,
    listOptions: vm.listOptions,
    categories: vm.product ? vm.product.categories : [],

    /* recommended_retail_price: vm.fixComma(data.recommended_retail_price),
    buy_price: vm.fixComma(data.buy_price),
    product_stock: vm.fixComma(data.product_stock),
    discount_percentage: vm.fixComma(data.discount_percentage), */

    // special_price: vm.fixComma(special_price),
  }
})

</script>

<style>

.SidebarFields .barcode-input {
  border-radius: 1px;
}

</style>

<style scoped>

.card-title {
  margin-top: 16px;
}

p {
  max-width: 410px;
  white-space: pre-wrap;
  margin: 0;
}

.product-wrapper {
  flex-basis: 410px;
  max-width: 410px;
  white-space: nowrap;
}

@media (max-width: 1500px) {
  .product-wrapper {
    flex-basis: 350px !important;
    max-width: 410px;
  }
}

.fullPage.product-wrapper {
  flex-basis: 100% !important;
  max-width: initial;
}

.product-sidebar {
  flex-basis: 100%;
  right: 0;
  max-height: 100%;
  flex-direction: column;
  overflow: auto;
  border-left: 1px solid var(--black-06);
}

.sidebar-section {
  border-top: 1px solid var(--black-06);
}

.inputs-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 14px;
  row-gap: 20px;
}

.inputs-grid > div {
  margin-bottom: 0px;
}

.categories, .list-options {
  border-top: 1px solid var(--black-06);
}

.add_new_tier_block_button{
  cursor: pointer;
  margin-bottom: 13px;
  margin-top: 13px;
}

.add_new_tier_block_button :hover {
  opacity: 0.7;
  cursor: pointer;
}

.tier_price_block {
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  padding: 10px 0;
}

.tier_price_block input {
  width: 30%;
  border: 1px solid rgba(0, 0, 0, 0.125);
  text-indent: 5px;
  height: 30px;
}

.tier_price_block span {
  margin: 0 5px !important;
}

.tier_price_block p {
  margin-top: 5px;
  margin-bottom: 3px !important;
}

.remove_tier_block {
  cursor: pointer;
  display: flex;
  justify-content: end;
}

.tier_section {
  margin-bottom: 20px;
}

</style>
